import { Button } from '../../ui/button';
import { Input } from '../../ui/input';
import { Card, CardContent } from '../../ui/card';
import { SortSelect } from '../../SortSelect';
import { IHALE_DURUMLARI, KONTROL_EK_SECENEKLER, IHALE_USULU_OPTIONS, ALIM_TURU_OPTIONS, TESIS_TURU_OPTIONS, SOZLESME_TURU_OPTIONS, IDARE_OPTIONS, ODENEK_DURUMU_OPTIONS, KESIN_KABUL_OPTIONS, labelOf } from './constants';

const chip = (active) => `h-6 px-2.5 text-xs ${active ? 'bg-blue-600 text-white hover:bg-blue-700' : 'bg-gray-800 text-gray-300 hover:bg-gray-700'}`;

function ChipGroup({ title, options, selected, onToggle, testPrefix }) {
  return (
    <div>
      <p className="text-xs text-gray-400 mb-1.5 font-semibold">{title}</p>
      <div className="flex flex-wrap gap-1.5">
        {options.map(o => (
          <Button key={o.value} size="sm" onClick={() => onToggle(o.value)} className={chip(selected.includes(o.value))} data-testid={testPrefix ? `${testPrefix}-${o.value}` : undefined}>{o.label}</Button>
        ))}
      </div>
    </div>
  );
}

export function IhaleFilters({
  filters, setFilters, toggleFilter, resetFilters,
  filterPanelOpen, setFilterPanelOpen, activeFilterCount,
  ihaleler, users, sortKey, setSortKey, filteredCount
}) {
  return (
    <Card className="bg-gray-900 border-gray-800 mb-4">
      <CardContent className="pt-4 pb-3">
        <div className="flex items-center justify-between mb-3">
          <Button onClick={() => setFilterPanelOpen(!filterPanelOpen)} variant="ghost" className="text-gray-300 hover:text-white px-3 h-8" data-testid="filter-toggle-btn">
            <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z" /></svg>
            Filtreleme {activeFilterCount > 0 && `(${activeFilterCount})`}
            <svg className={`w-4 h-4 ml-1 transition-transform ${filterPanelOpen ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" /></svg>
          </Button>
          <div className="flex items-center gap-3">
            <SortSelect value={sortKey} onChange={setSortKey} options={['newest','oldest','updated','name_asc','name_desc','amount_high','amount_low']} />
            <span className="text-xs text-gray-500">{filteredCount} / {ihaleler.length} ihale</span>
            {activeFilterCount > 0 && (
              <Button onClick={resetFilters} size="sm" variant="ghost" className="text-red-400 hover:text-red-300 h-7 text-xs">Filtreleri Temizle</Button>
            )}
          </div>
        </div>

        <div className="grid grid-cols-4 gap-3 mb-2">
          <Input placeholder="İhale No ara..." value={filters.ihale_no} onChange={(e) => setFilters({...filters, ihale_no: e.target.value})} className="bg-gray-800 border-gray-700 text-white text-xs h-8" />
          <Input placeholder="İş adı ara..." value={filters.isin_adi} onChange={(e) => setFilters({...filters, isin_adi: e.target.value})} className="bg-gray-800 border-gray-700 text-white text-xs h-8" />
          <Input placeholder="Firma ara..." value={filters.ihaleyi_alan_firma} onChange={(e) => setFilters({...filters, ihaleyi_alan_firma: e.target.value})} className="bg-gray-800 border-gray-700 text-white text-xs h-8" />
          <Input placeholder="Açıklama ara..." value={filters.aciklama} onChange={(e) => setFilters({...filters, aciklama: e.target.value})} className="bg-gray-800 border-gray-700 text-white text-xs h-8" />
        </div>

        {filterPanelOpen && (
          <div className="space-y-3 pt-2 border-t border-gray-800">
            <div className="grid grid-cols-2 gap-4">
              <div>
                <p className="text-xs text-gray-400 mb-1.5 font-semibold">Yıl</p>
                <div className="flex flex-wrap gap-1.5">
                  {[...new Set(ihaleler.map(i => i.yil?.toString()))].filter(Boolean).sort((a, b) => b - a).map(year => (
                    <Button key={year} size="sm" onClick={() => toggleFilter('yil', year)} className={`h-6 px-2.5 text-xs ${filters.yil.includes(year) ? 'bg-blue-600 text-white hover:bg-blue-700' : 'bg-gray-800 text-gray-300 hover:bg-gray-700'}`}>{year}</Button>
                  ))}
                </div>
              </div>
              <ChipGroup title="İhale Usulü" options={IHALE_USULU_OPTIONS} selected={filters.ihale_usulu} onToggle={(v) => toggleFilter('ihale_usulu', v)} />
            </div>
            <div className="grid grid-cols-3 gap-4">
              <ChipGroup title="Alım Türü" options={ALIM_TURU_OPTIONS} selected={filters.alim_turu} onToggle={(v) => toggleFilter('alim_turu', v)} />
              <ChipGroup title="Sözleşme Türü" options={SOZLESME_TURU_OPTIONS} selected={filters.sozlesme_turu} onToggle={(v) => toggleFilter('sozlesme_turu', v)} />
              <ChipGroup title="Tesis Türü" options={TESIS_TURU_OPTIONS} selected={filters.tesis_turu} onToggle={(v) => toggleFilter('tesis_turu', v)} testPrefix="filter-tesis-turu" />
            </div>
            <div>
              <p className="text-xs text-gray-400 mb-1.5 font-semibold">İlçe</p>
              <div className="flex flex-wrap gap-1.5">
                {[...new Set(ihaleler.map(i => i.ilcesi).filter(Boolean))].sort().map(ilce => (
                  <Button key={ilce} size="sm" onClick={() => toggleFilter('ilcesi', ilce)} className={`h-6 px-2.5 text-xs ${filters.ilcesi.includes(ilce) ? 'bg-blue-600 text-white hover:bg-blue-700' : 'bg-gray-800 text-gray-300 hover:bg-gray-700'}`}>{ilce}</Button>
                ))}
              </div>
            </div>
            <div>
              <p className="text-xs text-gray-400 mb-1.5 font-semibold">İşi Yapan İdare</p>
              <div className="flex flex-wrap gap-1.5">
                {[...new Set(ihaleler.map(i => i.isi_yapan_idare).filter(Boolean))].sort().map(idare => (
                  <Button key={idare} size="sm" onClick={() => toggleFilter('isi_yapan_idare', idare)} className={chip(filters.isi_yapan_idare.includes(idare))}>{labelOf(IDARE_OPTIONS, idare)}</Button>
                ))}
              </div>
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div>
                <p className="text-xs text-gray-400 mb-1.5 font-semibold">Durum</p>
                <div className="flex flex-wrap gap-1.5">
                  {IHALE_DURUMLARI.map(d => (
                    <Button key={d.value} size="sm" onClick={() => toggleFilter('durumu', d.value)} className={chip(filters.durumu.includes(d.value))}>{d.label}</Button>
                  ))}
                </div>
              </div>
              <div>
                <p className="text-xs text-gray-400 mb-1.5 font-semibold">Ödenek Durumu</p>
                <div className="flex flex-wrap gap-1.5">
                  {[...new Set(ihaleler.map(i => i.odenek_durumu).filter(Boolean))].sort().map(od => (
                    <Button key={od} size="sm" onClick={() => toggleFilter('odenek_durumu', od)} className={chip(filters.odenek_durumu.includes(od))}>{labelOf(ODENEK_DURUMU_OPTIONS, od)}</Button>
                  ))}
                </div>
              </div>
            </div>
            <div>
              <p className="text-xs text-gray-400 mb-1.5 font-semibold">Gelen Ödenek Tarihi Aralığı</p>
              <div className="grid grid-cols-2 gap-3 max-w-md">
                <div>
                  <label className="text-xs text-gray-500">Başlangıç</label>
                  <Input
                    type="date"
                    value={filters.odenek_tarihi_bas}
                    onChange={(e) => setFilters({...filters, odenek_tarihi_bas: e.target.value})}
                    className="bg-gray-800 border-gray-700 text-white text-xs h-8"
                    data-testid="filter-odenek-tarihi-bas"
                  />
                </div>
                <div>
                  <label className="text-xs text-gray-500">Bitiş</label>
                  <Input
                    type="date"
                    value={filters.odenek_tarihi_bit}
                    onChange={(e) => setFilters({...filters, odenek_tarihi_bit: e.target.value})}
                    className="bg-gray-800 border-gray-700 text-white text-xs h-8"
                    data-testid="filter-odenek-tarihi-bit"
                  />
                </div>
              </div>
              <p className="text-[11px] text-gray-500 mt-1">Aralık girildiğinde ödenek tarihi olmayan kayıtlar listelenmez.</p>
            </div>
            <div className="grid grid-cols-3 gap-4">
              <div>
                <p className="text-xs text-gray-400 mb-1.5 font-semibold">Kesin Kabul Durumu</p>
                <div className="flex flex-wrap gap-1.5">
                  {[...new Set(ihaleler.map(i => i.kesin_kabul_durumu).filter(Boolean))].sort().map(kd => (
                    <Button key={kd} size="sm" onClick={() => toggleFilter('kesin_kabul_durumu', kd)} className={chip(filters.kesin_kabul_durumu.includes(kd))}>{labelOf(KESIN_KABUL_OPTIONS, kd)}</Button>
                  ))}
                </div>
              </div>
              <div>
                <p className="text-xs text-gray-400 mb-1.5 font-semibold">Fiyat Farkı</p>
                <div className="flex flex-wrap gap-1.5">
                  {[{v:'var',l:'Var'},{v:'yok',l:'Yok'}].map(f => (
                    <Button key={f.v} size="sm" onClick={() => toggleFilter('fiyat_farki', f.v)} className={`h-6 px-2.5 text-xs ${filters.fiyat_farki.includes(f.v) ? 'bg-blue-600 text-white hover:bg-blue-700' : 'bg-gray-800 text-gray-300 hover:bg-gray-700'}`}>{f.l}</Button>
                  ))}
                </div>
              </div>
              <div>
                <p className="text-xs text-gray-400 mb-1.5 font-semibold">İş Artışı</p>
                <div className="flex flex-wrap gap-1.5">
                  {[{v:'var',l:'Var'},{v:'yok',l:'Yok'}].map(a => (
                    <Button key={a.v} size="sm" onClick={() => toggleFilter('is_artisi_1', a.v)} className={`h-6 px-2.5 text-xs ${filters.is_artisi_1.includes(a.v) ? 'bg-blue-600 text-white hover:bg-blue-700' : 'bg-gray-800 text-gray-300 hover:bg-gray-700'}`}>{a.l}</Button>
                  ))}
                </div>
              </div>
            </div>
            <div>
              <p className="text-xs text-gray-400 mb-1.5 font-semibold">İlgilenen Memur</p>
              <div className="flex flex-wrap gap-1.5">
                {users.map(u => (
                  <Button key={u.id} size="sm" onClick={() => toggleFilter('ilgilenen_memur', u.id)} className={`h-6 px-2.5 text-xs ${filters.ilgilenen_memur.includes(u.id) ? 'bg-blue-600 text-white hover:bg-blue-700' : 'bg-gray-800 text-gray-300 hover:bg-gray-700'}`}>{u.name}</Button>
                ))}
              </div>
            </div>
            <div>
              <p className="text-xs text-gray-400 mb-1.5 font-semibold">Kontrol Teşkilatı</p>
              <div className="flex flex-wrap gap-1.5">
                {[...users, ...KONTROL_EK_SECENEKLER].map(u => (
                  <Button key={u.id} size="sm" onClick={() => toggleFilter('kontrol_teskilati', u.id)} className={`h-6 px-2.5 text-xs ${filters.kontrol_teskilati.includes(u.id) ? 'bg-blue-600 text-white hover:bg-blue-700' : 'bg-gray-800 text-gray-300 hover:bg-gray-700'}`}>{u.name}</Button>
                ))}
              </div>
            </div>
            <div>
              <p className="text-xs text-gray-400 mb-1.5 font-semibold">Parasal Filtreler (Minimum TL)</p>
              <div className="grid grid-cols-3 gap-3">
                <div>
                  <label className="text-xs text-gray-500">Yaklaşık Maliyet</label>
                  <Input type="number" placeholder="Min TL..." value={filters.yaklasik_maliyet_min} onChange={(e) => setFilters({...filters, yaklasik_maliyet_min: e.target.value})} className="bg-gray-800 border-gray-700 text-white text-xs h-8" />
                </div>
                <div>
                  <label className="text-xs text-gray-500">Sözleşme Bedeli</label>
                  <Input type="number" placeholder="Min TL..." value={filters.sozlesme_bedeli_min} onChange={(e) => setFilters({...filters, sozlesme_bedeli_min: e.target.value})} className="bg-gray-800 border-gray-700 text-white text-xs h-8" />
                </div>
                <div>
                  <label className="text-xs text-gray-500">Hakediş</label>
                  <Input type="number" placeholder="Min TL..." value={filters.hakedis_min} onChange={(e) => setFilters({...filters, hakedis_min: e.target.value})} className="bg-gray-800 border-gray-700 text-white text-xs h-8" />
                </div>
              </div>
            </div>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
